import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

/**
 * Função utilitária para fazer scroll suave para o topo
 */
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
};

/**
 * Componente Link personalizado que sempre leva ao topo da página
 * Substitui o Link do React Router com funcionalidade de scroll automático
 */
export const ScrollLink = ({ to, children, className, onClick, ...props }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    
    // Executa onClick personalizado se fornecido
    if (onClick) {
      onClick(e);
    }
    
    // Navega para a rota
    navigate(to);
    
    // Scroll para o topo
    scrollToTop();
  };

  return (
    <RouterLink 
      to={to} 
      className={className} 
      onClick={handleClick}
      {...props}
    >
      {children}
    </RouterLink>
  );
};

/**
 * Componente Button personalizado que faz scroll para o topo
 * Útil para botões que executam ações e devem levar ao topo
 */
export const ScrollButton = ({ onClick, children, scrollToTop: shouldScroll = true, ...props }) => {

  const handleClick = (e) => {
    // Executa a função onClick original
    if (onClick) {
      onClick(e);
    }
    
    // Faz scroll para o topo se habilitado
    if (shouldScroll) {
      // Pequeno delay para permitir que a ação seja completada primeiro
      setTimeout(scrollToTop, 100);
    }
  };

  return (
    <button onClick={handleClick} {...props}>
      {children}
    </button>
  );
};

export default ScrollLink;
